module.exports = __webpack_public_path__ + "static/img/leumi.f6474eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-30/leumi.svg
// module id = OCvp
// module chunks = 6